import { styled, Divider, Stack, Typography, IconButton, Box, useMediaQuery, SwipeableDrawer } from '@mui/material';
import Logo from '../../common/Logo';
import {
  ArticleRounded,
  ArticleTwoTone,
  CampaignRounded,
  CampaignTwoTone,
  CardGiftcardRounded,
  CardGiftcardTwoTone,
  CelebrationRounded,
  CelebrationTwoTone,
  EmojiEventsRounded,
  EmojiEventsTwoTone,
  EventRounded,
  EventTwoTone,
  ExitToApp,
  ExitToAppOutlined,
  ExitToAppTwoTone,
  FastfoodRounded,
  FastfoodTwoTone,
  HomeTwoTone,
  PermContactCalendarRounded,
  PermContactCalendarTwoTone,
  Settings,
  SettingsAccessibility,
} from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { selectDrawerOpen } from '../../features/Search/searchSlice';
import MuiDrawer from '@mui/material/Drawer';
import { variants } from '../../variants/variants';
import { cloneElement, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import WidgetsOutlined from '@mui/icons-material/WidgetsOutlined';
import { useLogoutMutation } from '../../features/Auth/authApiSlice';
import { clearAuth } from '../../features/Auth/Utility/ClearAuth';
import { setLayout } from '../../features/Auth/authSlice';

const drawerWidth = 300;
const openedMixin = (theme) => ({
  width: drawerWidth,
  height: '100%',
  transition: 'none',
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  height: '100%',
  transition: 'none',
  overflowX: 'hidden',
  width: `calc(${theme.spacing(12)} + 5px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(11)} + 5px)`,
  },
});

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  border: 'none',
  zIndex: 1000,
  overflow: 'hidden',
  '& .MuiDrawer-paper': {
    width: open ? drawerWidth : `calc(${theme.spacing(11)} + 5px)`,
    overflowX: 'hidden',
    height: '100vh',
    position: 'fixed',
    transition: 'none',
    border: 'none',
    boxShadow: theme.shadows[3],
    [theme.breakpoints.down('sm')]: {
      width: open ? '100%' : 0,
    },
  },
  ...(open ? openedMixin(theme) : closedMixin(theme)),
}));

const navigations = [
  { title: 'User', path: 'user', icon: <PermContactCalendarTwoTone /> },
  { title: 'Delights', path: 'delights', icon: <FastfoodTwoTone /> },
  { title: 'GIFT', path: 'gift', icon: <CardGiftcardTwoTone /> },
  { title: 'RnR', path: 'rnr', icon: <EmojiEventsTwoTone /> },
  { title: 'Shabash', path: 'shabash', icon: <CelebrationTwoTone /> },
  { title: 'Pings', path: 'announcement', icon: <CampaignTwoTone /> },
  { title: 'GNN', path: 'gnn', icon: <ArticleTwoTone /> },
  { title: 'Settigns', path: 'settings', icon: <Settings /> },
];
const Left = ({ state, toggleDrawer }) => {
  const open = useSelector(selectDrawerOpen);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [logout] = useLogoutMutation();

  const isActive = (path) => {
    const currentPage = pathname.split('/')[2];
    return currentPage === path;
  };
  const handleNavigate = (nav) => {
    navigate(nav.path);
  };

  const handleLogout = async () => {
    logout();
    clearAuth(dispatch);
    navigate('/auth');
  };
  const handleHomeClick = () => {
    dispatch(setLayout('home'));
    navigate('/home');
  };
  const content = (open) => (
    <Box sx={{ height: '100%' }}>
      <Logo width={open ? '54.5%' : '67%'} icon={!open} centre={!open} />
      <Divider />
      <Stack sx={{ p: 1 }}>
        {navigations.map((url, index) => (
          <Stack
            key={index}
            direction={open ? 'row' : 'column'}
            alignItems={'center'}
            onClick={() => handleNavigate(url)}
            sx={{
              mb: 1,
              borderRadius: variants.boxRadius.SIDEBAR,
              p: 1.5,
              cursor: 'default',
              background: isActive(url.path) ? variants.hover.active : 'transparent',
              ':hover': {
                background: isActive(url.path) ? variants.hover.active : variants.hover.inactive,
              },
            }}
          >
            {cloneElement(url.icon, {
              sx: isActive(url.path) ? { color: variants.primary } : { color: variants.icon.inactive.background },
            })}
            <Typography
              sx={{
                ml: open ? 2 : 0,
                fontSize: open ? variants.BODY : variants.TINY,
                fontWeight: isActive(url.path) ? 700 : 600,
                color: isActive(url.path) ? variants.typography.active.main : variants.typography.inactive.hover,
              }}
            >
              {url.title}
            </Typography>
          </Stack>
        ))}
        <Divider />
        <Stack
          direction={open ? 'row' : 'column'}
          alignItems={'center'}
          onClick={handleHomeClick}
          sx={{
            mt: 1,
            borderRadius: variants.boxRadius.SIDEBAR,
            p: 1.5,
            cursor: 'default',
            background: 'transparent',
            ':hover': {
              background: variants.hover.inactive,
            },
          }}
        >
          <HomeTwoTone
            sx={{
              color: variants.icon.inactive.background,
            }}
          />
          <Typography
            sx={{
              ml: open ? 2 : 0,
              fontSize: open ? variants.BODY : variants.TINY,
              fontWeight: 400,
              color: variants.typography.active.hover,
            }}
          >
            Home
          </Typography>
        </Stack>
        <Stack
          direction={open ? 'row' : 'column'}
          alignItems={'center'}
          onClick={handleLogout}
          sx={{
            mt: 0,
            borderRadius: variants.boxRadius.SIDEBAR,
            p: 1.5,
            cursor: 'default',
            background: 'transparent',
            ':hover': {
              background: variants.hover.inactive,
            },
          }}
        >
          <ExitToAppTwoTone
            sx={{
              color: variants.icon.inactive.background,
            }}
          />
          <Typography
            sx={{
              ml: open ? 2 : 0,
              fontSize: open ? variants.BODY : variants.TINY,
              fontWeight: 400,
              color: variants.typography.active.hover,
            }}
          >
            Sign out
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  return isMobile ? (
    <SwipeableDrawer
      anchor={'left'}
      open={state}
      onClose={toggleDrawer(false)}
      onOpen={toggleDrawer(true)}
      sx={{
        '.MuiPaper-root': {
          width: 300,
        },
      }}
    >
      {content(state)}
    </SwipeableDrawer>
  ) : (
    <Drawer variant="permanent" open={open}>
      {content(open)}
    </Drawer>
  );
};

export default Left;
